import nxtChampion from "../../assets/img/roster/champions/NXTChampion.png";
import northAmericanChampion from "../../assets/img/roster/champions/NAChampion.png";
import nxtTagChampions from "../../assets/img/roster/champions/NXTTagChampions.png";
import nxtWomenChampion from "../../assets/img/roster/champions/NXTWomenChampion.png";
import nxtWomenNaChampion from "../../assets/img/roster/champions/NAWomenChampion.png";

import logo2010 from "../../assets/img/brands/NXTLogo/LogoEditions/2010-2012.png";
import logo2012 from "../../assets/img/brands/NXTLogo/LogoEditions/2012-2014.png";
import logo2014 from "../../assets/img/brands/NXTLogo/LogoEditions/2014-2019.png";
import logo2019 from "../../assets/img/brands/NXTLogo/LogoEditions/2019-2021.png";
import logo2021a from "../../assets/img/brands/NXTLogo/LogoEditions/2021-2021.png";
import logo2021b from "../../assets/img/brands/NXTLogo/LogoEditions/2021-2022.png";
import logo2022 from "../../assets/img/brands/NXTLogo/LogoEditions/2022-2024.png";
import logoCurrent from "../../assets/img/brands/NXTLogo/LogoEditions/Current.png";

import specialGoldRush2023 from "../../assets/img/brands/NXTLogo/LogoSpecials/GoldRush2023.png";
import specialGoldRush2025 from "../../assets/img/brands/NXTLogo/LogoSpecials/GoldRush2025.png";
import specialHomecoming2025 from "../../assets/img/brands/NXTLogo/LogoSpecials/Homecoming2025.png";
import specialNxt2300 from "../../assets/img/brands/NXTLogo/LogoSpecials/NXT2300-2024.png";
import specialNewYearsEvil2021 from "../../assets/img/brands/NXTLogo/LogoSpecials/NewYearsEvil2021.png";
import specialNewYearsEvil2022 from "../../assets/img/brands/NXTLogo/LogoSpecials/NewYearsEvil2022.png";
import specialNewYearsEvil2023 from "../../assets/img/brands/NXTLogo/LogoSpecials/NewYearsEvil2023.png";
import specialNewYearsEvil2024 from "../../assets/img/brands/NXTLogo/LogoSpecials/NewYearsEvil2024.png";
import specialNewYearsEvil2025 from "../../assets/img/brands/NXTLogo/LogoSpecials/NewYearsEvil2025.png";
import specialNewYearsEvil2026 from "../../assets/img/brands/NXTLogo/LogoSpecials/NewYearsEvil2026.png";
import specialRevenge2026 from "../../assets/img/brands/NXTLogo/LogoSpecials/Revenge2026.png";
import specialRoadblock2022 from "../../assets/img/brands/NXTLogo/LogoSpecials/Roadblock2022.png";
import specialRoadblock2023_2024 from "../../assets/img/brands/NXTLogo/LogoSpecials/Roadblock2023-2024.png";
import specialRoadblock2025 from "../../assets/img/brands/NXTLogo/LogoSpecials/Roadblock2025.png";
import specialShowdown2025 from "../../assets/img/brands/NXTLogo/LogoSpecials/Showdown2025.png";
import specialSpringBreakin from "../../assets/img/brands/NXTLogo/LogoSpecials/SpringBreakin2022-2024.png";
import specialSuperTuesday2020 from "../../assets/img/brands/NXTLogo/LogoSpecials/SuperTuesday2020.png";
import specialSuperTuesdayII from "../../assets/img/brands/NXTLogo/LogoSpecials/SuperTuesdayII.png";

export const nxtDetail = {
  id: "nxt",
  title: "NXT",
  subtitle: "Explore the current champions and the brand logo.",
  tabs: [
    {
      id: "champions",
      label: "Champions",
      variant: "nxt",
      items: [
        {
          id: "tony-d'angelo",
          title: "Tony D'Angelo",
          description: "NXT Champion",
          imgUrl: nxtChampion,
        },
        {
          id: "myles-borne",
          title: "Myles Borne",
          description: "NXT North American Champion",
          imgUrl: northAmericanChampion,
        },
        {
          id: "borne-heights",
          title: "Myles Borne & Tavion Heights",
          description: "NXT Tag Team Champions",
          imgUrl: nxtTagChampions,
        },
        {
          id: "kendal-grey",
          title: "Kendal Grey",
          description: "NXT Women´s Champion",
          imgUrl: nxtWomenChampion,
        },
        {
          id: "Zaria",
          title: "Zaria",
          description: "NXT Women´s North American Champion",
          imgUrl: nxtWomenNaChampion,
        },
      ],
    },
    {
      id: "logos",
      label: "Editions",
      variant: "nxt",
      items: [
        {
          id: "nxt-logo-2010-2012",
          title: "NXT",
          description: "2010 - 2012",
          imgUrl: logo2010,
        },
        {
          id: "nxt-logo-2012-2014",
          title: "NXT",
          description: "2012 - 2014",
          imgUrl: logo2012,
        },
        {
          id: "nxt-logo-2014-2019",
          title: "NXT",
          description: "2014 - 2019",
          imgUrl: logo2014,
        },
        {
          id: "nxt-logo-2019-2021",
          title: "NXT",
          description: "2019 - 2021",
          imgUrl: logo2019,
        },
        {
          id: "nxt-logo-2021-2021",
          title: "NXT",
          description: "2021",
          imgUrl: logo2021a,
        },
        {
          id: "nxt-logo-2021-2022",
          title: "NXT 2.0",
          description: "2021 - 2022",
          imgUrl: logo2021b,
        },
        {
          id: "nxt-logo-2022-2024",
          title: "NXT",
          description: "2022 - 2024",
          imgUrl: logo2022,
        },
        {
          id: "nxt-logo-current",
          title: "NXT",
          description: "Current",
          imgUrl: logoCurrent,
        },
      ],
    },
    {
      id: "specials",
      label: "Specials",
      variant: "nxt",
      items: [
        {
          id: "nxt-special-super-tuesday-2020",
          title: "Super Tuesday",
          description: "NXT special episode: Week 1 2020",
          imgUrl: specialSuperTuesday2020,
        },
        {
          id: "nxt-special-super-tuesday-2",
          title: "Super Tuesday II",
          description: "NXT special episode: Week 2 2020",
          imgUrl: specialSuperTuesdayII,
        },
        {
          id: "nxt-special-new-years-evil-2021",
          title: "New Year's Evil",
          description: "NXT special episode 2021",
          imgUrl: specialNewYearsEvil2021,
        },
        {
          id: "nxt-special-new-years-evil-2022",
          title: "New Year's Evil",
          description: "NXT special episode 2022",
          imgUrl: specialNewYearsEvil2022,
        },
        {
          id: "nxt-special-roadblock-2022",
          title: "Roadblock",
          description: "NXT special episode 2022",
          imgUrl: specialRoadblock2022,
        },
        {
          id: "nxt-special-spring-breakin",
          title: "Spring Breakin'",
          description: "NXT special episodes 2022 - 2024",
          imgUrl: specialSpringBreakin,
        },
        {
          id: "nxt-special-new-years-evil-2023",
          title: "New Year's Evil",
          description: "NXT special episode 2023",
          imgUrl: specialNewYearsEvil2023,
        },
        {
          id: "nxt-special-roadblock-2023-2024",
          title: "Roadblock",
          description: "NXT special episode 2023 - 2024",
          imgUrl: specialRoadblock2023_2024,
        },
        {
          id: "nxt-special-gold-rush-2023",
          title: "Gold Rush",
          description: "NXT special episode 2023",
          imgUrl: specialGoldRush2023,
        },
        {
          id: "nxt-special-new-years-evil-2024",
          title: "New Year's Evil",
          description: "NXT special episode 2024",
          imgUrl: specialNewYearsEvil2024,
        },
        {
          id: "nxt-special-2300",
          title: "2300",
          description: "NXT special episode 2024",
          imgUrl: specialNxt2300,
        },
        {
          id: "nxt-special-new-years-evil-2025",
          title: "New Year's Evil",
          description: "NXT special episode 2025",
          imgUrl: specialNewYearsEvil2025,
        },
        {
          id: "nxt-special-roadblock-2025",
          title: "Roadblock",
          description: "NXT special episode 2025",
          imgUrl: specialRoadblock2025,
        },
        {
          id: "nxt-special-homecoming-2025",
          title: "Homecoming",
          description: "NXT special episode 2025",
          imgUrl: specialHomecoming2025,
        },
        {
          id: "nxt-special-showdown-2025",
          title: "Showdown",
          description: "NXT special episode: NXT Vs. TNA 2025",
          imgUrl: specialShowdown2025,
        },
        {
          id: "nxt-special-gold-rush-2025",
          title: "Gold Rush",
          description: "NXT special episode 2025",
          imgUrl: specialGoldRush2025,
        },
        {
          id: "nxt-special-new-years-evil-2026",
          title: "New Year's Evil",
          description: "NXT special episode 2026",
          imgUrl: specialNewYearsEvil2026,
        },
        {
          id: "nxt-special-revenge-2026",
          title: "Revenge",
          description: "NXT special episode 2026",
          imgUrl: specialRevenge2026,
        },
      ],
    },
  ],
};
